module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-en-US.d3ab8274.jpg";